import React, { useEffect, useState, useRef } from "react";

import { ReactComponent as ArrowPrevIcon } from "../../assets/svg/arrow-previous.svg";
import { ReactComponent as ArrowNextIcon } from "../../assets/svg/arrow-next.svg";
import { ReactComponent as MeetQIcon } from "../../assets/svg/meetq-logo.svg";
import { ReactComponent as ScanIcon } from "../../assets/svg/scan.svg";
import { ReactComponent as ArrowDownIcon } from "../../assets/svg/arrow-down.svg";
import { ReactComponent as SlotFilterIcon } from "../../assets/svg/filter-search.svg";
import { ReactComponent as SlotCloseIcon } from "../../assets/svg/close-1.svg";
import { ReactComponent as FilterCloseIcon } from "../../assets/svg/close-filter.svg";
import { ReactComponent as CalendarIcon } from "../../assets/svg/calendar-outline.svg";
import { ReactComponent as SearchIcon } from "../../assets/svg/search.svg";
import { ReactComponent as EditIcon } from "../../assets/svg/edit-icon.svg";

import RoomImage from "../../assets/png/room-image.png";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { DayPicker, rangeContainsDayOfWeek } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { format, parse } from "date-fns";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Form, Button, InputGroup } from "react-bootstrap";
import Header from "../common/Header";
import { getCookie } from "../getcookie.js";
import LoaderModal from "../common/Loader.js";
import { ReactComponent as NoRecordsFound } from "../../assets/svg/no-records-found.svg";
import { Toast, ToastContainer } from "react-bootstrap";
import { useGlobal } from "../../GlobalContext.js";

export default function MyBookingList() {
  const { selectedMenu, setSelectedMenu } = useGlobal();
  const apiUrl = process.env.REACT_APP_API_URL;

  const navigate = useNavigate();

  const scrollRefs = useRef([]);

  const scrollLeft = (index) => {
    const ref = scrollRefs.current[index];
    if (ref) {
      ref.scrollBy({ left: -100, behavior: "smooth" });
    }
  };

  const scrollRight = (index) => {
    const ref = scrollRefs.current[index];
    if (ref) {
      ref.scrollBy({ left: 100, behavior: "smooth" });
    }
  };

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [selectedTap, setTapValue] = useState("upcoming");
  const [selectedOffice, setOfficeValue] = useState("");
  const [selectedFloor, setFloorValue] = useState("");

  const [orgImage, setOrgImg] = useState("");
  const [selectedCategory, setCategoryValue] = useState("");
  const [selectedSlot, setSlotValue] = useState("30 mins");
  const [selectedBookId, setBookId] = useState([]);
  const [bookIdList, setBookIdList] = useState([]);
  const [categoryList, setCategory] = useState([]);

  const [floorList, setFloors] = useState([]);
  const [roomList, setRooms] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const openModal = (id, index) => {
    setRoomIndex(index);
    setRoomId(id);
    setIsOpen(true);
  };
  const [visibleRooms, setVisibleRooms] = useState([]);
  const [offset, setOffset] = useState(0);
  const limit = 10;

  const closeModal = () => setIsOpen(false);
  const [selectedRoomId, setRoomId] = useState(-1);
  const [selectedRoomIndex, setRoomIndex] = useState(-1);
  const [upcomingCount, setUpcomingCount] = useState(0);
  const [pastCount, setPastCount] = useState(0);

  const [showTitle, setShowTitle] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState("");

  const menuBoxInactive = { cursor: "pointer", width: "128px", height: "44px", display: "flex", justifyContent: "center", alignItems: "center" };
  const menuBoxActive = { cursor: "pointer", width: "128px", height: "44px", display: "flex", justifyContent: "center", alignItems: "center", borderBottom: "3px solid #842234" };
  const menuColorActive = { fontSize: "15px", fontWeight: "700", lineHeight: "17.17px", color: "#842234" };
  const menuColorInactive = { fontSize: "15px", fontWeight: "400", lineHeight: "17.17px", color: "#1E1E1E" };
  const profileName = { fontSize: "14px", fontWeight: "700", color: "#842234" };
  const title = { fontSize: "24px", fontWeight: "800", color: "#1E1E1E" };
  const subtitle = { fontSize: "15px", fontWeight: "400", color: "#81878C" };
  const roomTitle = { fontSize: "18px", fontWeight: "500", color: "#1E1E1E" };
  const seatCount = { fontSize: "13.5px", fontWeight: "400", color: "#81878C", marginTop: "8px" };
  const availableTitle = { fontSize: "12px", fontWeight: "400", color: "#81878C", marginBottom: "8px" };
  const availableName = { fontSize: "12.5px", fontWeight: "400", color: "#21272C" };
  const slotTitle = { fontSize: "13px", fontWeight: "700", color: "#1E1E1E" };
  const slotTitleSelected = { fontSize: "12px", fontWeight: "500", color: "#842234" };
  const filterTitle = { fontSize: "24px", fontWeight: "700", color: "#1E1E1E" };
  const officeTitle = { marginTop: "16px", marginBottom: "8px", fontSize: "15px", fontWeight: "700", lineHeight: "17.17px", color: "#1E1E1E" };
  const modalStyle = {
    overlay: { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", opacity: 0.8, display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 },
    modal: { backgroundColor: "#ffffff", padding: "16px 24px", borderRadius: "16px", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", width: "328px", height: "229px", textAlign: "center" },
  };

  const handleCategoryClick = (category) => {
    setCategoryValue(category);
  };

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };
  const handleSearch = debounce((term) => {
    console.log("Searching for:", term);
    fetchOptions(selectedTap === "upcoming" ? "upcoming" : "past", term);
  }, 1000);

  const fetchOptions = async (type, term, newOffset = 0, append = false) => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(apiUrl + `booking`, {
        params: { type: type, search: term, offset: newOffset, limit: limit },
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: getCookie("mawalog"),
        },
      });

      if (response.data.success === true) {
        setUpcomingCount(response.data.upcoming);
        setPastCount(response.data.past);
        setShowTitle(response.data.show_name);
        setOrgImg(response.data.org_image);

        if (response.data.bookings.length > 0) {
          if (append) {
            setVisibleRooms((prev) => [...prev, ...response.data.bookings]);
          } else {
            setVisibleRooms(response.data.bookings);
          }
          setRooms(response.data.bookings); // keep for compatibility
        } else if (!append) {
          setVisibleRooms([]);
          setRooms([]);
        }
      }
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };

  // Initial load
  useEffect(() => {
    setSelectedMenu("My Bookings");
    setOffset(0);
    fetchOptions("upcoming", "", 0, false);
  }, []);

  // When tab changes, reset offset and visibleRooms
  useEffect(() => {
    setOffset(0);
    fetchOptions(selectedTap, searchInputValue, 0, false);
  }, [selectedTap]);

  // Infinite scroll handler
  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop <= e.target.clientHeight + 10;
    // Check if all items are loaded
    const totalCount = selectedTap === "upcoming" ? upcomingCount : pastCount;
    console.log("visiblelength", visibleRooms.length);
    console.log("totalCount", upcomingCount);
    if (bottom && !loading && visibleRooms.length < totalCount) {
      const newOffset = offset + limit;
      setOffset(newOffset);
      fetchOptions(selectedTap, searchInputValue, newOffset, true);
    }
  };

  useEffect(() => {
    setSelectedMenu("My Bookings");
    fetchOptions("upcoming", "");
  }, []);

  useEffect(() => {
    console.log("Updated showTitle:", showTitle);
  }, [showTitle]);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [cancelBookingId, setCancelBookingId] = useState(null);
  const alertRefCancelBooking = useRef(null);
  const handleClickOutside = (event) => {
    if (alertRefCancelBooking.current && !alertRefCancelBooking.current.contains(event.target)) {
      setIsOpenDelete(false);
    }
  };
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const cancelBookingDialog = async (id, index) => {
    setCancelBookingId({ id: id, index: index });
    setIsOpenDelete(true);
  };
  const cancelBooking = async () => {
    setLoading(true);
    setError(null);

    try {
      const data = {};
      const headers = {
        "Content-Type": "application/json; charset=UTF-8",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: getCookie("mawalog"),
      };
      const response = await axios.put(apiUrl + `cancel_booking/` + cancelBookingId.id, data, { headers: headers }).catch((error) => {
        if (error.response) {
          console.error("Error Status:", error.response.status);
          console.error("Error Data:", error.response.data);
          if (error.response.status === 500) {
            setSnackbarMessage(error.response.data.message);
            setSnackbarStatus(false);
            handleSnackbarShow();
            setRooms((prevRooms) => {
              const updatedArray = [...prevRooms];
              if (updatedArray[cancelBookingId.index] !== undefined) {
                updatedArray[cancelBookingId.index]["error_msg"] = error.response.data.message;
              }
              return updatedArray;
            });
          }
        } else {
          console.error("Request failed:", error.message);
        }
      });

      // const data = await response.json();
      if (response.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(true);
        handleSnackbarShow();
        setIsOpenDelete(false);
        fetchOptions(selectedTap === "upcoming" ? "upcoming" : "past", "");
      }
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const checkInOutMeeting = async (id, status, index) => {
    setLoading(true);
    setError(null);

    try {
      const data = {};
      const headers = {
        "Content-Type": "application/json; charset=UTF-8",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        Authorization: getCookie("mawalog"),
      };
      const response = await axios
        .put(apiUrl + (status === "Pending" ? "check_in_booking" : "check_out_booking") + "/" + id, data, { headers: headers })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.success === true) {
              fetchOptions(selectedTap === "upcoming" ? "upcoming" : "past", "");
            }
          }
          if (response.status === 500) {
            setRooms((prevRooms) => {
              const updatedArray = [...prevRooms];
              if (updatedArray[index] !== undefined) {
                updatedArray[index]["error_msg"] = response.data.message;
              }
              return updatedArray;
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            console.error("Error Status:", error.response.status);
            console.error("Error Data:", error.response.data);
            if (error.response.status === 500) {
              setRooms((prevRooms) => {
                const updatedArray = [...prevRooms];
                if (updatedArray[index] !== undefined) {
                  updatedArray[index]["error_msg"] = error.response.data.message;
                }
                return updatedArray;
              });
            }
          } else {
            console.error("Request failed:", error.message);
          }
        });
      console.log("response.status", response.status);
      console.log("message", response.data.message);
      // const data = await response.json();
    } catch (err) {
      console.error("Error fetching options:", err);
      setError("Failed to fetch options. Try again.");
    } finally {
      setLoading(false);
    }
  };
  const cancelModalStyle = {
    overlay: { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", opacity: 1, display: "flex", justifyContent: "center", alignItems: "center" },
    modal: { backgroundColor: "#ffffff", padding: "40px", borderRadius: "16px", boxShadow: "0 4px 6px rgba(0, 0, 0, 1)", width: "436px", height: "180px", textAlign: "center" },
  };

  return (
    <Container fluid className="GTWalsheimTrial px-0">
      {/* <Header selectedTab={'My Bookings'} /> */}

      <Row className="flex-wrap px-3" style={{ height: "calc(100vh - 68px)", overflow: "auto", scrollbarWidth: "none", msOverflowStyle: "none", justifyContent: "center" }}>
        <Col sm={12} xl={8} style={{ padding: "16px", justifyContent: "center" }}>
          <div style={title}>Your bookings listed here!</div>
          &nbsp;&nbsp;
          <div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                onClick={() => {
                  setTapValue("upcoming");
                  fetchOptions("upcoming", "");
                }}
                style={selectedTap === "upcoming" ? menuBoxActive : menuBoxInactive}
              >
                <div style={selectedTap === "upcoming" ? menuColorActive : menuColorInactive}>Upcoming {upcomingCount}</div>
              </div>
              <div
                onClick={() => {
                  setTapValue("past");
                  fetchOptions("past", "");
                }}
                style={selectedTap === "past" ? menuBoxActive : menuBoxInactive}
              >
                <div style={selectedTap === "past" ? menuColorActive : menuColorInactive}>Past {pastCount}</div>
              </div>
            </div>
          </div>
          &nbsp;&nbsp;
          <Form>
            <Form.Group style={{ borderRadius: "100px", border: "0.6px solid #E5E5E5", overflow: "hidden" }} className="mb-4">
              <InputGroup>
                <Button variant="outline-secondary" style={{ backgroundColor: "#ffffff", border: "none", outline: "none", boxShadow: "none" }}>
                  <SearchIcon />
                </Button>
                <Form.Control
                  className="custom-input"
                  type="text"
                  placeholder="Search..."
                  value={searchInputValue}
                  onChange={(event) => {
                    setSearchInputValue(event.target.value);

                    handleSearch(event.target.value);
                  }}
                  style={{ border: "none", outline: "none", boxShadow: "none" }}
                />
              </InputGroup>
            </Form.Group>
          </Form>
          <div style={{ height: "calc(100vh - 300px)", overflow: "scroll", scrollbarWidth: "none", msOverflowStyle: "none" }} onScroll={handleScroll}>
            {visibleRooms.map((item, roomIndex) => (
              <>
                <div className="mt-3 d-flex flex-column mb-4" style={{}}>
                  <div className="d-flex flex-column px-4 py-2" style={{ backgroundColor: "#FFd6DD", width: "100%", borderTopLeftRadius: "24px", borderTopRightRadius: "24px" }}>
                    <div>{item["title"]}</div>
                    {showTitle && <div>{item["user"]}</div>}
                  </div>

                  <Row
                    onClick={() => {
                      navigate("/mybooking-view", { state: { id: item["id"] } });
                    }}
                    key={`${roomIndex}-room`}
                    style={{ cursor: "pointer", paddingTop: "24px", paddingBottom: "24px", paddingRight: "32px", background: "#ffffff", display: "flex", justifyContent: "space-between", alignItems: "center" }}
                  >
                    {/* <Row md={12} className="justify-content-between"> */}
                    {/* <div>{showTitle} "Not working"</div> */}

                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <div style={{ marginLeft: "8px", display: "flex", alignItems: "center", justifyContent: "start" }}>
                        <div style={{ width: "36px", height: "36px", borderRadius: "100px" }}>
                          <img src={orgImage !== "" ? orgImage : RoomImage} alt="org" style={{ width: "36px", height: "36px", borderRadius: "100px" }} />
                        </div>
                        <div style={{ marginLeft: "8px" }}>
                          <div style={{ fontSize: "16px", fontWeight: "700", color: "#1E1E1E" }}>{item["office"] ?? ""}</div>
                          <div style={{ fontSize: "13px", fontWeight: "500", color: "#842234" }}>{item["floor_label"] ?? ""}</div>
                        </div>
                      </div>
                      <div style={{ textAlign: "center" }}>
                        <div style={{ display: "flex" }}>
                          {item["status"] === "Pending" && (
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                cancelBookingDialog(item["id"], roomIndex);
                              }}
                              style={{ cursor: "pointer", width: "135.5px", height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#ffffff", border: "1px solid #E5E5E5" }}
                            >
                              <div style={{ fontSize: "14px", fontWeight: "700", color: "#1E1E1E" }}>Cancel</div>
                            </div>
                          )}
                          {item["status"] === "Pending" && (
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                checkInOutMeeting(item["id"], item["status"], roomIndex);
                              }}
                              style={{ cursor: "pointer", width: "135.5px", height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#842234" }}
                            >
                              <div style={{ fontSize: "14px", fontWeight: "700", color: "#F3F6F9" }}>Check In</div>
                            </div>
                          )}

                          {item["status"] === "In-Progress" && (
                            <div
                              onClick={(e) => {
                                e.stopPropagation();
                                checkInOutMeeting(item["id"], item["status"], roomIndex);
                              }}
                              style={{ cursor: "pointer", width: "135.5px", height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#842234" }}
                            >
                              <div style={{ fontSize: "14px", fontWeight: "700", color: "#F3F6F9" }}>Checkout</div>
                            </div>
                          )}

                          {item["status"] === "Cancelled" && (
                            <div style={{ height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                              <div style={{ fontSize: "14px", fontWeight: "700", color: "#FF4444" }}>Cancelled</div>
                            </div>
                          )}

                          {item["status"] === "Expired" && (
                            <div style={{ height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                              <div style={{ fontSize: "14px", fontWeight: "700", color: "#FF4444" }}>Expired</div>
                            </div>
                          )}

                          {item["status"] === "Completed" && (
                            <div style={{ height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "100px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                              <div style={{ fontSize: "14px", fontWeight: "700", color: "#20824A" }}>Checked out</div>
                            </div>
                          )}
                        </div>
                        <div style={{ fontSize: "14px", fontWeight: "700", color: "#FF4444" }}> {item["error_msg"]} </div>
                      </div>
                    </div>
                    <div style={{ padding: "16px", marginTop: "16px", marginLeft: "16px", marginRight: "24px", borderRadius: "24px", background: "#F6F7F9" }}>
                      <div style={{ display: "flex" }}>
                        <img src={item["image"] != null && item["image"] !== "" ? item["image"] : RoomImage} alt="room" style={{ width: "36px", height: "36px", borderRadius: "6px" }} />
                        <div style={{ marginLeft: "16px" }}>
                          <div style={{ fontSize: "15px", fontWeight: "500", color: "#1E1E1E" }}>{item["room"] ?? ""}</div>

                          <div style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                            <div style={{ fontSize: "13px", fontWeight: "400", color: "#1E1E1E", opacity: 0.6 }}>{item["capacity"] ?? "0"} Seater</div> &nbsp;&nbsp; <div style={{ width: "3px", height: "3px", backgroundColor: "#D9D9D9" }}></div>&nbsp;&nbsp;
                            <div style={{ fontSize: "14px", fontWeight: "400", color: "#81878C" }}>{item["category"] ?? ""}</div>
                          </div>
                        </div>
                      </div>
                      <div style={{ fontSize: "13px", fontWeight: "400", color: "#1E1E1E" }}>Booked on</div>
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                        <div style={{ fontSize: "14px", fontWeight: "500", color: "#842234" }}>{item["date_time"] ?? ""}</div> &nbsp;{" "}
                        {selectedTap === "upcoming" && (
                          <EditIcon
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate("/reschedule", { state: { id: item["id"], date: item["date"], formatted_date: item["date_time"] } });
                            }}
                          />
                        )}
                      </div>
                    </div>
                    {/* </Row> */}
                  </Row>
                </div>
              </>
            ))}
            {visibleRooms.length === 0 && (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <NoRecordsFound />
                <div style={{ marginTop: "8px", fontSize: "16px", fontWeight: "500", color: "#212129" }}>No records found</div>
                <div style={{ fontSize: "13px", fontWeight: "400", color: "#8790A1" }}>Looks like you haven’t any data to show</div>
              </div>
            )}
            {visibleRooms.length > 0 && ((selectedTap === "upcoming" && visibleRooms.length >= upcomingCount) || (selectedTap === "past" && visibleRooms.length >= pastCount)) && <div style={{ textAlign: "center", color: "#842234", margin: "16px 0", fontWeight: "500" }}>No more Bookings</div>}
          </div>
        </Col>
      </Row>
      <LoaderModal show={loading} />
      {isOpenDelete && (
        <div style={cancelModalStyle.overlay} backdrop="static">
          <div ref={alertRefCancelBooking} style={cancelModalStyle.modal}>
            <div style={{ color: "#ffffff" }}>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <div style={{ fontSize: "20px", fontWeight: "700", color: "#1E1E1E" }}>Cancel Booking</div>
                <div style={{ marginTop: "8px", fontSize: "16px", fontWeight: "400", color: "#1E1E1E" }}> Are you sure want to cancel booking?</div>

                <div style={{ flex: 12, marginTop: "8px", display: "flex", flexDirection: "row", alignItems: "start", justifyContent: "start" }}>
                  <div
                    onClick={() => {
                      setIsOpenDelete(false);
                    }}
                    style={{ width: "158px", height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "8px", display: "flex", flex: 6, justifyContent: "center", alignItems: "center", border: "1px solid #E5E5E5" }}
                  >
                    <div style={{ fontSize: "16px", fontWeight: "500", color: "#1E1E1E" }}>Close</div>
                  </div>
                  <div
                    onClick={() => {
                      cancelBooking();
                    }}
                    style={{ width: "158px", height: "44px", marginLeft: "8px", marginRight: "8px", borderRadius: "8px", display: "flex", flex: 6, justifyContent: "center", alignItems: "center", background: "#FF4444" }}
                  >
                    <div style={{ fontSize: "16px", fontWeight: "500", color: "#FFFFFF" }}>Cancel</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          {/*  <Toast.Header>
            <strong className="mr-auto">Snackbar Title</strong>
          </Toast.Header> */}
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
}
